import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { AlertCircle, Rocket, ShieldCheck } from "lucide-react";

/**
 * Banner environment indicator: DEMO / PILOT / PRODUCTION.
 * - DEMO / STAGING → tampil ke semua pengguna sebagai peringatan data uji.
 * - PILOT → tampil ke semua pengguna sebagai indikator masa uji terbatas.
 * - PRODUCTION → SEMBUNYI untuk pengguna biasa. Hanya Super Admin yang melihat
 *   badge kecil (sebagai indikator internal bahwa sistem berjalan resmi).
 */
export function EnvBanner() {
  const [env, setEnv] = useState(null);
  const { user } = useAuth();

  useEffect(() => {
    let mounted = true;
    api.get("/system/env").then((r) => {
      if (mounted) setEnv(r.data);
    }).catch(() => {});
    return () => { mounted = false; };
  }, []);

  if (!env) return null;

  const isSuperAdmin = user && user.role === "SUPER_ADMIN";
  const isProduction = env.env === "PRODUCTION";
  const isPilot = !!env.pilot_mode;
  const isDemoOrStaging = ["DEMO", "STAGING"].includes(env.env);

  // Aturan visibilitas
  if (isProduction && !isPilot) {
    // Sembunyikan sepenuhnya untuk non Super Admin. Super Admin lihat badge ringkas.
    if (!isSuperAdmin) return null;
    return (
      <div
        className="w-full text-white text-[11px] font-semibold py-1 px-3 flex items-center justify-center gap-2 print:hidden"
        style={{ backgroundColor: "#22a06b" }}
        data-testid="env-banner"
      >
        <ShieldCheck className="h-3 w-3 flex-shrink-0" />
        <span className="tracking-wide">PRODUCTION</span>
        <span className="hidden sm:inline opacity-80">— Mode resmi. Semua data dan transaksi tercatat.</span>
      </div>
    );
  }

  // DEMO / STAGING / PILOT → tampil ke semua
  if (!isDemoOrStaging && !isPilot) return null;

  const label = isPilot ? "PILOT MODE" : "DEMO / DATA UJI";
  const color = isPilot ? "#E5B52A" : "#dd6b20";
  const Icon = isPilot ? Rocket : AlertCircle;
  const msg = isPilot
    ? "Aplikasi sedang dalam masa uji coba terbatas oleh Klasis + jemaat pilot."
    : "Data pada tampilan ini adalah DATA UJI (bukan data resmi Klasis). Purge sebelum go-live.";

  return (
    <div
      className="w-full text-white text-xs sm:text-sm font-semibold py-1.5 px-3 flex items-center justify-center gap-2 print:hidden"
      style={{ backgroundColor: color }}
      data-testid="env-banner"
    >
      <Icon className="h-3.5 w-3.5 flex-shrink-0" />
      <span className="tracking-wide">{label}</span>
      <span className="hidden sm:inline opacity-80">— {msg}</span>
    </div>
  );
}

export default EnvBanner;
